const Const = {
    SOCIAL: {
        OTHER: 'ohter',
        ANDROID: 'android',
        IOS: 'ios',
    }
}

export default Const;